import React from 'react';
import { ModalUpdateInfoAboutObject } from './ModalUpdateInfoAboutObject/ModalUpdateInfoAboutObject';
import { ModalCustomer } from './ModalCustomer/ModalCustomer';
import { ModalAddManagerInfo } from './ModalAddManagerInfo/ModalAddManagerInfo';
import { ModalEditManagerInfo } from './ModalEditManagerInfo/ModalEditManagerInfo';
import { ModalShowManagerInfo } from './ModalShowManagerInfo/ModalShowManagerInfo';
import { useSelector } from 'react-redux';
import { WeatherModal } from './WeatherModal/WeatherModal';
import { ModalVisualization } from './ModalVisualization/ModalVisualization';
import { ModalTeamProject } from './ModalTeamProject/ModalTeamProject';

export const InformationModals = ({}) => {
    //@ts-ignore
    const { modalMode } = useSelector((state) => state.dashboardReducer);

    return (
        <>
            {modalMode === 'editInformation' && <ModalUpdateInfoAboutObject />}
            {modalMode === 'teamProject' && <ModalTeamProject />}
            {modalMode === 'addManager' && <ModalAddManagerInfo />}
            <ModalEditManagerInfo />
            {modalMode === 'addCustomer' || modalMode === 'editCustomer' ? <ModalCustomer /> : null}
            <ModalVisualization />
            <ModalShowManagerInfo />
            <WeatherModal />
        </>
    );
};
